import { useGlobalStore } from "@hooks/useGlobalStore";
import { isDev } from "@memorang/constants/src/urls";
import * as Application from "expo-application";
import Constants from "expo-constants";
import { type AppIds, Apps } from "types/apps";
import { isAndroid, isWeb } from "./platform";

//TODO: This module name does not make sense. also change getBuildType to getTargetApp, and buildType to targetApp
// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
const getBuildType = (): Apps | undefined => {
	if (isDev) {
		// Get stored app from GlobalStore if available
		const _selectedApp = useGlobalStore.getState().selectedApp;
		return Apps.TherapyEd;
	}

	if (isWeb) {
		const host =
			typeof window !== "undefined" ? window.location.hostname : "psiexams";

		if (host.includes("partners-beta")) {
			//TODO: Change this to other apps if you want to test different apps on beta
			return Apps.TherapyEd;
		}
		if (host.includes("partners")) {
			//TODO:Change this to other apps if you want to test different apps on preview
			return Apps.TherapyEd;
		}
		if (host.includes("therapyed")) {
			return Apps.TherapyEd;
		}
		if (host.includes("aviation.psiexams")) {
			return Apps.faa;
		}

		if (host.includes("cmaanet")) {
			return Apps.cmaa;
		}

		if (host.includes("nascla")) {
			return Apps.nascla;
		}
		if (host.includes("psiexams")) {
			return Apps.Psi;
		}
		if (host.includes("gowpi")) {
			return Apps.wpi;
		}

		if (host.includes("toefl")) {
			return Apps.toefl;
		}
		if (host.includes("jbjs")) {
			return Apps.Jbjs;
		}
		if (host.includes("cambridge")) {
			return Apps.cambridge;
		}
		if (host.includes("aavsb")) {
			return Apps.aavsb;
		}

		if (host.endsWith("memorang.app")) {
			return Apps.TherapyEd;
		}
		if (host.includes("wocncb")) {
			return Apps.wocncb;
		}
		return undefined;
	}
	const appId = Application.applicationId as AppIds;

	switch (appId) {
		case "com.memorang.therapyed":
			return Apps.TherapyEd;
		case "com.memorang.psi.insurance":
		case "com.memorang.psi.insurance.testprep":
			return Apps.Psi;
		case "org.ets.toeflpracticeaicoach":
			return Apps.toefl;
		case "com.memorang.psi.wpi":
			return Apps.wpi;
		case "com.memorang.jbjs":
		case "com.memorang.jbjs.image.challenge":
			return Apps.Jbjs;
		case "com.memorang.psi.aviation":
			return Apps.faa;
		case "com.memorang.cambridge.cupa.ema":
			return Apps.cambridge;
		case "com.memorang.aavsb":
			return Apps.aavsb;
		case "com.memorang.nascla":
			return Apps.nascla;
		case "com.memorang.psi.wocncb.testprep":
		case "com.memorang.psi.wocncb":
			return Apps.wocncb;
		case "com.memorang.psi.cmaa":
			return Apps.cmaa;
		default:
			return Apps.TherapyEd;
	}
};
const versionCode = isAndroid
	? Constants.expoConfig?.android?.versionCode
	: Constants.expoConfig?.ios?.buildNumber;
const buildType = getBuildType()!;

export { buildType, versionCode };
